import React from 'react';
import { MODULES } from './landingData';
import LandingSection from './LandingSection';
import LandingCard from './LandingCard';

export default function LandingModules() {
  return (
    <LandingSection
      id="modules"
      title="Modules"
      subtitle="Everything your school needs—enable what you want, keep the rest optional."
      innerClassName="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 lg:gap-4"
    >
        {MODULES.map((m) => {
          const Icon = m.icon;
          return (
            <LandingCard
              key={m.title}
              className="p-4 lg:p-5"
            >
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-blue-600/20">
                <Icon className="h-4 w-4 text-blue-400" />
              </div>
              <p className="mt-3 text-sm font-semibold text-white">{m.title}</p>
              <p className="mt-1 text-xs leading-relaxed text-white/50">{m.desc}</p>
            </LandingCard>
          );
        })}
    </LandingSection>
  );
}
